import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { BatchStock } from 'src/app/models/types/Product/Stock.type';
import { SharedService } from 'src/app/services/shared.service';

@Component({
  selector: 'app-batch-card',
  imports: [TranslateModule],
  templateUrl: './batch-card.component.html',
  styleUrl: './batch-card.component.scss'
})
export class BatchCardComponent {

  @Input('stock') stock!: BatchStock;

  @Output('handleSelectStock') handleSelectStock = new EventEmitter<BatchStock>();

  constructor(public readonly sharedServices: SharedService) { }

}
